import Modal from "components/blocks/Modal";
import useMutation from "hooks/useMutation";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OrdersService } from "services/orders";
import { useNotification } from "../../../../../../../../../hooks/useNotification";
import FormTextArea from "components/blocks/FormTextArea";

const EditRequestModal = ({
  isOpen,
  onClose,
  onConfirm,
  orderId,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  orderId: number;
}) => {
  const { t } = useTranslation(["Orders", "Common"]);
  const { showNotification } = useNotification();
  const [notes, setNotes] = useState("");
  const { loading: isSubmitting, mutateAsync } = useMutation({
    queryFn: async (notes: string) => {
      return await OrdersService.programOrderUpdateRequest(orderId, { notes });
    },
  });

  const onCancel = () => {
    onClose?.();
    setNotes("");
  };

  const onSubmit = async (notes: string) => {
    const res = await mutateAsync(notes);

    if (res && !res.hasError) {
      onConfirm();
      showNotification({ description: t("Common:success"), type: "success" });
      setNotes("");
    }
  };

  return (
    <Modal
      containerClassName="bg-white pb-2"
      isOpen={isOpen}
      onClose={onClose}
      title={t("updateRequest")}
      withHeaderBorder
      size="lg"
      titleClassName="fs-6 text-dark"
      bodyMargin="py-3"
    >
      <FormTextArea
        label={t("Common:notes")}
        placeholder={t("Common:notes")}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        rows={5}
        withAsterisk
      />

      <div className="divider mt-3"></div>

      <div className="d-flex justify-content-center gap-2 w-100">
        <button type="button" className="btn text-dark rounded-3 p-10-32P" onClick={onCancel}>
          {t("Common:cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary rounded-3 p-10-32P"
          disabled={!notes.length || isSubmitting}
          onClick={async () => {
            if (!notes.length) return;

            await onSubmit(notes);
          }}
        >
          {!isSubmitting ? t("send") : <div className="custom-loader"></div>}
        </button>
      </div>
    </Modal>
  );
};

export default EditRequestModal;
